var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import featureToggles from 'shared-assets/lib/sdk/featureToggles';
import rollbar from 'shared-assets/src/errors/errors';
import sharedConfig from 'shared-assets/src/config-environments/config';
import somePathAsserted from 'shared-assets/lib/utils/paths/path-assertion';
var WOOTRIC_NPS_SURVEY = 'dark-feature.wootric-nps-survey';
var WOOTRIC_NPS_SURVEY_IMMEDIATELY = 'dark-feature.wootric-nps-survey-immediately';
var WOOTRIC_REQUIRED_PROPERTIES = [
    'email',
    'companyType',
    'createdAt',
    'customerId',
    'practiceId',
    'pricingFamily',
    'roles',
];
export var WOOTRIC_SDK_SCRIPT_URL = 'https://cdn.wootric.com/wootric-sdk.js';
/** Class functionality to display Wootric surveys */
var Wootric = /** @class */ (function () {
    function Wootric() {
    }
    /** Loads the Wootric SDK functionality into the page adding an async script
     * @returns {Promise} - Returns a promise that resolves true if the Wootric SDK is properly loaded
     */
    Wootric.loadScript = function () {
        var scriptPromise = Promise.resolve(true);
        if (!document.querySelector('body > #wootric-beacon')) {
            scriptPromise = new Promise(function (resolve, reject) {
                try {
                    // Beacon
                    var beacon = document.createElement('script');
                    beacon.type = 'text/javascript';
                    beacon.id = 'wootric-beacon';
                    beacon.async = true;
                    beacon.src = WOOTRIC_SDK_SCRIPT_URL;
                    beacon.onload = function () {
                        resolve(true);
                    };
                    document.body.appendChild(beacon);
                }
                catch (error) {
                    reject(error);
                }
            });
        }
        return scriptPromise;
    };
    /**
     * Returns if the provided feature toggle is enabled or not for the current customer and practice.
     * @param feature - Name of the feature toggle that we need to check
     * @returns
     */
    Wootric.isFeatureToggleEnabled = function (feature) {
        return __awaiter(this, void 0, void 0, function () {
            var featureEnabled, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, featureToggles.isEnabled(feature)];
                    case 1:
                        featureEnabled = _a.sent();
                        return [2 /*return*/, Array.isArray(featureEnabled) ? featureEnabled[0] : featureEnabled];
                    case 2:
                        error_1 = _a.sent();
                        rollbar.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    /**
     * Checks if the NPS surver is enable and if it is then do an initialization
     * @param {InitializationFunction} initialization - Function that will do an initialization if the NPS is enable
     */
    Wootric.initializedIfNPSEnabled = function (initialization) {
        return __awaiter(this, void 0, void 0, function () {
            var isEnabled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Wootric.isFeatureToggleEnabled(WOOTRIC_NPS_SURVEY)];
                    case 1:
                        isEnabled = _a.sent();
                        if (isEnabled) {
                            initialization();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initialized the flags required by Wootric for cookies and test surveys
     */
    Wootric.setSurveyFlags = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        window.wootric_no_surveyed_cookie = (_a = sharedConfig === null || sharedConfig === void 0 ? void 0 : sharedConfig.wootric) === null || _a === void 0 ? void 0 : _a.noSurveyedCookie;
                        _b = window;
                        return [4 /*yield*/, Wootric.isFeatureToggleEnabled(WOOTRIC_NPS_SURVEY_IMMEDIATELY)];
                    case 1:
                        _b.wootric_survey_immediately = _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Return the Unix timestamp from the provided date that could be a number or Date
     * @param {Date | Number} date - The date value to extract the unix timestamp
     * @returns {Number} -  Returns a unix timestamp
     */
    Wootric.getUnitTimestampFromDate = function (date) {
        if (typeof date === 'number') {
            return date;
        }
        var dateValue = date instanceof Date ? date : new Date();
        return Math.floor(dateValue.getTime() / 1000);
    };
    /**
     * Set the Wootric Settings that identifies the account and the user
     * @param {Object} SurveyUserData - Receives an object that contain the user email and create at date
     */
    Wootric.setSurveySettings = function (_a) {
        var _b, _c, _d;
        var companyType = _a.companyType, createdAt = _a.createdAt, customerId = _a.customerId, email = _a.email, isPatientPopPartnerActive = _a.isPatientPopPartnerActive, practiceId = _a.practiceId, practiceSpecialty = _a.practiceSpecialty, pricingFamily = _a.pricingFamily, roles = _a.roles, userType = _a.userType, isPmDesktopUser = _a.isPmDesktopUser;
        window.wootricSettings = {
            account_token: (_b = sharedConfig === null || sharedConfig === void 0 ? void 0 : sharedConfig.wootric) === null || _b === void 0 ? void 0 : _b.accountToken,
            created_at: Wootric.getUnitTimestampFromDate(createdAt),
            email: email,
            product_name: (_c = sharedConfig === null || sharedConfig === void 0 ? void 0 : sharedConfig.wootric) === null || _c === void 0 ? void 0 : _c.product,
            properties: {
                company_type: companyType,
                customer_id: customerId,
                environment: sharedConfig === null || sharedConfig === void 0 ? void 0 : sharedConfig.environment,
                is_patientpop_partner_active: isPatientPopPartnerActive,
                practice_id: practiceId,
                practice_specialty: practiceSpecialty,
                pricing_family: pricingFamily,
                product: (_d = sharedConfig === null || sharedConfig === void 0 ? void 0 : sharedConfig.wootric) === null || _d === void 0 ? void 0 : _d.product,
                roles: roles === null || roles === void 0 ? void 0 : roles.sort().join(','),
                user_type: userType,
                is_pm_desktop_user: isPmDesktopUser,
            },
        };
    };
    /**
     * Runs the wootric survey
     */
    Wootric.run = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!((_a = window === null || window === void 0 ? void 0 : window.wootricSettings) === null || _a === void 0 ? void 0 : _a.email)) {
                    throw new Error('You should add the Wootric Settings before run the survey');
                }
                window.wootric('run');
                return [2 /*return*/];
            });
        });
    };
    /**
     * Load scripts, init global settings and run the Wootric survey
     * @param {Object} SurveyUserData - Receives an object that contain the user email and create at date
     */
    Wootric.initSurvey = function (settings) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var npsSurveyEnabled, scriptLoaded, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, Wootric.isFeatureToggleEnabled(WOOTRIC_NPS_SURVEY)];
                    case 1:
                        npsSurveyEnabled = _b.sent();
                        if (!(npsSurveyEnabled &&
                            !somePathAsserted(window.location.pathname + window.location.hash, (_a = sharedConfig === null || sharedConfig === void 0 ? void 0 : sharedConfig.wootric) === null || _a === void 0 ? void 0 : _a.untrackedPaths))) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all([
                                Wootric.loadScript(),
                                Wootric.setSurveyFlags(),
                            ])];
                    case 2:
                        scriptLoaded = (_b.sent())[0];
                        if (!scriptLoaded) {
                            throw new Error('The Wootric script should have loaded before run the survey');
                        }
                        Wootric.setSurveySettings(settings);
                        Wootric.run();
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_2 = _b.sent();
                        rollbar.error(error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Wootric.requiredFieldFilled = function (properties) {
        return WOOTRIC_REQUIRED_PROPERTIES.every(function (requiredProperty) {
            return properties.hasOwnProperty(requiredProperty);
        });
    };
    Wootric.InitSurveryProperties = function (properties) {
        var isReady, aditionalProperties;
        if (properties === void 0) { properties = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isReady = false;
                    _a.label = 1;
                case 1:
                    if (!!isReady) return [3 /*break*/, 3];
                    return [4 /*yield*/, isReady];
                case 2:
                    aditionalProperties = _a.sent();
                    if (aditionalProperties) {
                        properties = Object.assign(properties, aditionalProperties);
                    }
                    isReady = Wootric.requiredFieldFilled(properties);
                    return [3 /*break*/, 1];
                case 3:
                    Wootric.initSurvey(properties);
                    return [2 /*return*/];
            }
        });
    };
    Wootric.getInitializator = function () {
        if (!Wootric.propertiesInitializator) {
            Wootric.propertiesInitializator = Wootric.InitSurveryProperties({});
            Wootric.propertiesInitializator.next();
        }
        return Wootric.propertiesInitializator;
    };
    return Wootric;
}());
export default Wootric;
